<template>
  <div>
    <div v-if="gameType == GameType.ROUNDROBIN" class="columns round-robin">
      <div class="column">
        <div class="is-size-3 player-name" style="text-align: center; height: 500px;">
          (bye)
        </div>
      </div>
    </div>
  </div>

</template>

<style lang="scss" scoped>
</style>

<script>
import { GameType } from '@/enum/gameType.js';

export default {
  props: [
    'matchPlayer',
    'gameType'
  ],
  data () {
    return {
        GameType
    }
  },
  components : {
  },
  methods:{
  }
}
</script>
